import request from '../utils/request';
/* ip地址 */
export const getIPApi = () => {
  return request({
    url: '/sql/common/getIpAddr'
  })
}

/* ----登录相关--- */
//  账户密码登录-利用端登录
export const loginApi = (data) => {
  return request({
    url: '/login/web',
    method: 'post',
    data
  })
}
//IP登录
export const loginByIpApi = () => {
  return request({
    url: '/login/web/ip',
    method:'post'
  })
}
// 验证码
export const getValidateCodeApi = () => {
  return request({
    url: '/captcha',
    method:'get'
  })
}
// 登出
export const logoutApi = () => {
  return request({
    url: '/logout',
    method:'get'
  })
}

export const cookieLogin = () => {
  return request({
    url: '/sql/common/loginByCookie',
    method: 'get',
    params: {
      productCode: 'MEDICAL'
    }
  })
}
export const ipLogin = () => {
  return request({
    url: '/sql/common/loginByIp',
    method: 'get',
    params: {
      productCode: 'MEDICAL'
    }
  })
}
export const guestLogin = () => {
  return request({
    url: '/sql/common/loginByGuest',
    method: 'get',
    params: {
      productCode: 'MEDICAL'
    }
  })
}
// 网络登录
export const netLogin = (netStr) => {
  return request({
    url: '/sql/common/loginByNST?productCode=MEDICAL&' + netStr,
    method: 'get'
  })
}
//获取秘钥
export const getRSABase64PublicKey = () => {
  return request({
    url: '/sql/common/getRSABase64PublicKey',
  })
}
// 重置密码
export const resetPass = (data) => {
  return request({
    url: '/sql/common/login/resetPass',
    method: 'post',
    data
  })
}

// 获取用户信息
export const getUserInfo = () => {
  return request({
    url: '/parse',
    method: 'get'
  })
}
/* --------------首页---------------- */
export const searchModuleDataListApi = (params) => {
  return request({
    url: '/medical/data/searchModuleDataList',
    method: 'get',
    params
  })
}



/* ------------------列表接口----------------- */
export const getAggApi = (data) => {
  return request({
    url: '/medical/data/agg',
    method: 'post',
    data
  })
}
export const searchListApi = (data) => {
  return request({
    url: '/medical/data/searchList',
    method: 'post',
    data
  })
}
export const getProductStaticDataApi = (moduleCode) => {
  return request({
    url: '/sql/access/getProductStaticData',
    method: 'get',
    params: {
      productCode: 'MEDICAL',
      moduleCode
    }
  })
}
export const getSearchFieldsApi = (params) => {
  return request({
    url: '/medical/data/getSearchFields',
    params
  })
}
export const topicListApi = (params) => {
  return request({
    url: '/sql/access/topicList',
    params
  })
}
export const topicAggApi = (params) => {
  return request({
    url: '/sql/access/topicAgg',
    params
  })
}




/* 详情页 */
export const detailApi = (data) => {
  return request({
    url: '/medical/data/searchOne',
    method: 'post',
    data
  })
}

export const relateApi = (data) => {
  return request({
    url: '/medical/data/searchRelateList',
    method: 'post',
    data
  })
}

export const addHome = (data) => {
  return request({
    url: '/sql/access/addModuleData',
    method: 'post',
    data
  })
}
export const addCommentApi = (data) => {
  return request({
    url: '/sql/access/addComment',
    method: 'post',
    data
  })
}
export const getCommentListApi = (params) => {
  return request({
    url: '/sql/access/getCommentList',
    params
  })
}
export const deleteCommentApi = (params) => {
  return request({
    url: '/sql/access/deleteComment',
    params
  })
}




/* 高级检索 */
export const listEventTypeApi = () => {
  return request({
    url: '/medical/data/listEventType'
  })
}

/* 数据统计页面 */
export const getUpdateInfoApi = () => {
  return request({
    url: '/sql/access/getUpdateInfo'
  })
}
export const initUpdateInfo = () => {
  return request({
    url: '/sql/access/initUpdateInfo'
  })
}


/* 图谱 */
// 展开节点

/* 地图 */
export const mapSearchApi = (params) => {
  return request({
    url: '/medical/data/mapSearch',
    params
  })
}

/* 资源导航 */
export const getWeaponTypeInfoByParentApi = (params) => {
  return request({
    url: '/sql/access/getWeaponTypeInfoByParent',
    params
  })
}
// 客户分类
export const getCollegeTypeApi = () => {
  return request({
    url: '/sql/access/getCollegeType'
  })
}
export const getAreaInfoApi = () => {
  return request({
    url: '/sql/access/getAreaInfo',
  })
}


/* 对比页 */
export const getVsListApi = (id) => {
  return request({
    url: '/medical/data/contrast',
    params: {
      id
    }
  })
}



/* -----------------科技报告图谱项目----------------------------- */
export const searchNodeApi = (data) => {
  return request({
    url: '/medical/graph/searchNodes',
    method: 'post',
    data
  })
}
export const expandNodeApi = (data) => {
  return request({
    url: '/medical/data/expandNode',
    method: 'post',
    data
  })
}
/* 项目负责人TOP10 */
export const getAuthorTop10Api = () => {
  return request({
    url: '/medical/data/getAuthorTop10'
  })
}
/* 技术领域TOP10 */
export const getTechAreaTop10Api = (params) => {
  return request({
    url: '/medical/data/getTechAreaTop10',
    params
  })
}


/* 获取详情成果和项目 */
export const listAchievementApi = (params) => {
  return request({
    url: '/medical/data/listAchievement',
    params
  })
}

/* 个人中心相关 */
// 获取状态信息收藏、点赞、关注
export const favStateApi = (params) => {
  return request({
    url: '/sql/access/usercenter/fav/state',
    params
  })
}
// 添加 favType=1点赞、2收藏、3关注
export const favAddApi = (data) => {
  return request({
    url: '/sql/access/usercenter/fav/add',
    method: 'post',
    data
  })
}
// 取消收藏
export const favDelApi = (data) => {
  return request({
    url: '/sql/access/usercenter/fav/del',
    method: 'post',
    data
  })
}
// 获取点赞、收藏次数
export const countsApi = (params) => {
  return request({
    url: '/sql/access/counts',
    params
  })
}
// 获取收藏记录
export const getFavRecordsApi = (data) => {
  return request({
    url: '/sql/access/usercenter/getFavRecords',
    method: 'post',
    data
  })
}
// 获取浏览记录
export const getViewRecordsApi = (data) => {
  return request({
    url: '/sql/access/usercenter/getViewRecords',
    method: 'post',
    data
  })
}



/* 添加到首页 */
export const addModuleDataApi = (data) => {
  return request({
    url: '/sql/access/addModuleData',
    method: 'post',
    data
  })
}

/* 获取底部友情链接 */
export const getFriendlyLinkLisApi = () => {
  return request({
    url: '/sql/access/getFriendlyLinkLis'
  })
}
/* 获取信息专栏 */
export const getInfoBannerApi = () => {
  return request({
    url: '/sql/access/getInfoBanner'
  })
}

// 军事部署检索
export const mapForceSearch = (key, type) => {
  return request({
    url: '/military/data/mapForceSearch',
    params: {
      type, key
    }
  })
}
export const mapForceSearchDetail = (id, dataType) => {
  return request({
    url: '/military/data/mapForceSearchDetail',
    params: {
      id, dataType
    }
  })
}


// 搜索词联想
export const getSearchThinkApi = (params)=>{
  return request({
    url:'/elastic/getSearchThink',
    params
  })
}